import React, { FC, ReactNode, useCallback } from 'react';
import { UnleashContext, UnleashToggleNames } from '../context/UnleashContext.tsx';
import { useQuery } from '@tanstack/react-query';
import { UnleashController } from '../../api/services/UnleashController.ts';
import LoaderWrapper from '../../components/atoms/loading/LoaderWrapper.tsx';
import styled from 'styled-components';

interface UnleashContextProps {
	children: ReactNode;
}

const UnleashProvider: FC<UnleashContextProps> = ({ children }) => {
	const result = useQuery({
		queryKey: ['unleash'],
		refetchOnWindowFocus: false,
		queryFn: UnleashController.getAllToggles,
	});

	const isToggleEnabled = useCallback(
		(toggleName: UnleashToggleNames) => {
			// Hvis vi ikke får noen toggles er ingenting lov
			if (result.error) {
				return false;
			}
			return result.data?.data?.find((toggle) => toggle.name === toggleName)?.status || false;
		},
		[result.data?.data, result.error]
	);

	return (
		<UnleashContext.Provider
			value={{
				toggles: result.data?.data || [],
				isToggleEnabled,
			}}
		>
			<StyledLoaderWrapper loading={result.isLoading} description='Laster inn...'>
				{children}
			</StyledLoaderWrapper>
		</UnleashContext.Provider>
	);
};

export default UnleashProvider;

const StyledLoaderWrapper = styled(LoaderWrapper)`
	height: 100dvh;
`;
